export default class MathUtil {
    public static cleanNumber(value: number, precision: number = 10, buffer: number = 3) {
        if (value !== undefined && value !== null && !isNaN(value)) {
            let numPrecision = Number(Math.round(parseFloat(value + 'e' + precision)) + 'e-' + precision);
            return precision > buffer ? numPrecision.toFixed(precision - buffer) : Math.round(numPrecision).toString();
        }
        return '';
    }

    public static isUndefined(value: number) {
        if (value === undefined) {
            return true;
        } else {
            return false;
        }
    }

    public static cleanDollarAmount(value: number) {
        if (isNaN(value)) {
            return '';
        }

        // account for values less than 1/10th of a cent when rounding.
        let returnVal = value * 100;
        if (returnVal % 1 <= 0.1) {
            return (Math.floor(returnVal) / 100).toFixed(2);
        }

        return (Math.ceil(returnVal) / 100).toFixed(2);
    }

    // tslint:disable-next-line: variable-name
    public static numberToEnglish(n: number, custom_join_character?: string) {
        let dataString = n.toString(),
            units,
            tens,
            scales,
            start,
            end,
            chunks,
            chunksLen,
            chunk,
            ints,
            i,
            word,
            words;

        const and = custom_join_character || 'and';

        /* Is number zero? */
        if (parseInt(dataString, 10) === 0) {
            return 'zero';
        }

        /* Array of units as words */
        // tslint:disable: max-line-length
        units = [
            '',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine',
            'ten',
            'eleven',
            'twelve',
            'thirteen',
            'fourteen',
            'fifteen',
            'sixteen',
            'seventeen',
            'eighteen',
            'nineteen',
        ];

        /* Array of tens as words */
        tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        /* Array of scales as words */
        scales = [
            '',
            'thousand',
            'million',
            'billion',
            'trillion',
            'quadrillion',
            'quintillion',
            'sextillion',
            'septillion',
            'octillion',
            'nonillion',
            'decillion',
            'undecillion',
            'duodecillion',
            'tredecillion',
            'quatttuor-decillion',
            'quindecillion',
            'sexdecillion',
            'septen-decillion',
            'octodecillion',
            'novemdecillion',
            'vigintillion',
            'centillion',
        ];

        /* Split user arguemnt into 3 digit chunks from right to left */
        start = dataString.length;
        chunks = [];
        while (start > 0) {
            end = start;
            chunks.push(dataString.slice((start = Math.max(0, start - 3)), end));
        }

        /* Check if function has enough scale words to be able to dataStringify the user argument */
        chunksLen = chunks.length;
        if (chunksLen > scales.length) {
            return '';
        }

        /* dataStringify each integer in each chunk */
        words = [];
        for (i = 0; i < chunksLen; i++) {
            chunk = parseInt(chunks[i], 10);

            if (chunk) {
                /* Split chunk into array of individual integers */
                ints = chunks[i].split('').reverse().map(parseFloat);

                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if (ints[1] === 1) {
                    ints[0] += 10;
                }

                /* Add scale word if chunk is not zero and array item exists */
                if ((word = scales[i])) {
                    words.push(word);
                }

                /* Add unit word if array item exists */
                if ((word = units[ints[0]])) {
                    words.push(word);
                }

                /* Add tens word if array item exists */
                if ((word = tens[ints[1]])) {
                    words.push(word);
                }

                /* Add 'and' dataString after units or tens integer if: */
                if (ints[0] || ints[1]) {
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if (ints[2] || (!i && chunksLen)) {
                        words.push(and);
                    }
                }

                /* Add hundreds word if array item exists */
                if ((word = units[ints[2]])) {
                    words.push(word + ' hundred');
                }
            }
        }

        return words.reverse().join(' ');
    }

    // tslint:disable-next-line: variable-name
    // public static numberToEnglish(n: number, custom_join_character?: string) {
    //     let dataString = n.toString(),
    //         units,
    //         tens,
    //         scales,
    //         start,
    //         end,
    //         chunks,
    //         chunksLen,
    //         chunk,
    //         ints,
    //         i,
    //         word,
    //         words;

    //     const and = custom_join_character || 'and';

    //     /* Is number zero? */
    //     if (parseInt(dataString, 10) === 0) {
    //         return 'zero';
    //     }

    //     /* Array of units as words */
    //     // tslint:disable: max-line-length
    //     units = [
    //         '',
    //         'one',
    //         'two',
    //         'three',
    //         'four',
    //         'five',
    //         'six',
    //         'seven',
    //         'eight',
    //         'nine',
    //         'ten',
    //         'eleven',
    //         'twelve',
    //         'thirteen',
    //         'fourteen',
    //         'fifteen',
    //         'sixteen',
    //         'seventeen',
    //         'eighteen',
    //         'nineteen',
    //     ];

    //     /* Array of tens as words */
    //     tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    //     /* Array of scales as words */
    //     scales = [
    //         '',
    //         'thousand',
    //         'million',
    //         'billion',
    //         'trillion',
    //         'quadrillion',
    //         'quintillion',
    //         'sextillion',
    //         'septillion',
    //         'octillion',
    //         'nonillion',
    //         'decillion',
    //         'undecillion',
    //         'duodecillion',
    //         'tredecillion',
    //         'quatttuor-decillion',
    //         'quindecillion',
    //         'sexdecillion',
    //         'septen-decillion',
    //         'octodecillion',
    //         'novemdecillion',
    //         'vigintillion',
    //         'centillion',
    //     ];

    //     /* Split user argument into 3 digit chunks from right to left */
    //     start = dataString.length;
    //     chunks = [];
    //     while (start > 0) {
    //         end = start;
    //         chunks.push(dataString.slice((start = Math.max(0, start - 3)), end));
    //     }

    //     /* Check if function has enough scale words to be able to stringify the user argument */
    //     chunksLen = chunks.length;
    //     if (chunksLen > scales.length) {
    //         return '';
    //     }

    //     /* stringify each integer in each chunk */
    //     words = [];
    //     for (i = 0; i < chunksLen; i++) {
    //         chunk = parseInt(chunks[i], 10);

    //         if (chunk) {
    //             /* Split chunk into array of individual integers */
    //             ints = chunks[i].split('').reverse().map(parseFloat);

    //             /* If tens integer is 1, i.e. 10, then add 10 to units integer */
    //             if (ints[1] === 1) {
    //                 ints[0] += 10;
    //             }

    //             /* Add scale word if chunk is not zero and array item exists */
    //             if ((word = scales[i])) {
    //                 words.push(word);
    //             }

    //             /* Add unit word if array item exists */
    //             if ((word = units[ints[0]])) {
    //                 words.push(word);
    //             }

    //             /* Add tens word if array item exists */
    //             if ((word = tens[ints[1]])) {
    //                 words.push(word);
    //             }

    //             /* Add 'and' after units or tens integer if: */
    //             if (ints[0] || ints[1]) {
    //                 /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
    //                 if (ints[2] || (!i && chunksLen)) {
    //                     words.push(and);
    //                 }
    //             }

    //             /* Add hundreds word if array item exists */
    //             if ((word = units[ints[2]])) {
    //                 words.push(word + ' hundred');
    //             }
    //         }
    //     }

    //     // Adding commas
    //     let result = words.reverse().join(' ');
    //     result = result.replace(/,$/, ''); // Remove trailing comma if any
    //     result = result.replace(/\band\b/, ', and'); // Add comma before 'and' if exists
    //     return result;
    // }

    public static round(value: number, precision: number) {
        if (value && !isNaN(value) && precision && !isNaN(precision)) {
            return parseFloat(value.toPrecision(precision));
        } else {
            return undefined;
        }
    }

    /**
     * @param top - The numerator (i.e. 1)
     * @param bottom - The denominator (i.e. 3)
     * @returns The fraction given (numerator and denominator) to an English representation; (i.e. 1/3  =>  'One-third')
     */
    public static fractionToEnglish(top: string, bottom: string) {
        try {
            let numeratorDigit = parseInt(top, 10);
            let denominatorDigit = parseInt(bottom, 10);
            let numerator = this.numberToEnglish(numeratorDigit);
            let denominator = this.numberToEnglish(denominatorDigit);

            // This is necessary because it will replace thousand with thous 
            if (numerator.startsWith('and')) {
                numerator = numerator.replace('and ', '');
            }

            if (denominator.startsWith('and')) {
                denominator = denominator.replace('and ', '');
            }

            denominator = denominator.replace('one ', '');

            // Single digit outliers x/1, x/2, x/3
            if (denominatorDigit <= 3) {
                if (top === bottom || numeratorDigit > denominatorDigit) {
                    return `All`;
                } else if (top === '1') {
                    if (bottom === '2') { 
                        denominator = 'half'; 
                    } else if (bottom === '3') { 
                        denominator = 'third'; 
                    } 
                } else if (top >= '1') {
                    if (bottom === '2') { 
                        denominator = 'halves'; 
                    } else if (bottom === '3') { 
                        denominator = 'thirds';
                    } 
                }
            } else {
                // Denominator is singular
                if (top === '1' && bottom !== '1' && bottom !== '2' && bottom !== '3') {
                    // Twenty, Thirty, Fourty, etc.
                    if (bottom.endsWith('0') && denominator.endsWith('y')) {
                        // Remove 'y'
                        denominator = denominator.slice(0, denominator.length - 1);
                        denominator += 'ie';
                    // Five => Fifth OR Twelve => Twelfth
                    } else if ((bottom.endsWith('2') || bottom.endsWith('5')) && denominator.endsWith('e')) {
                        // Remove 've'
                        denominator = denominator.slice(0, denominator.length - 2);
                        denominator += 'f';
                    // Eight => Eighth
                    } else if (bottom.endsWith('8')) {
                        // Remove 't'
                        denominator = denominator.slice(0, denominator.length - 1);
                    }
                    denominator += 'th';
                // Denominator is plural
                } else if (numeratorDigit > 1 && bottom !== '1' && bottom !== '2' && bottom !== '3') {
                    // Twenty, Thirty, Fourty, etc.
                    if (bottom.endsWith('0') && denominator.endsWith('y')) {
                        // Remove 'y'
                        denominator = denominator.slice(0, denominator.length - 1);
                        denominator += 'ie';
                    // Five => Fifths OR Twelve => Twelfths
                    } else if ((bottom.endsWith('2') || bottom.endsWith('5')) && denominator.endsWith('e')) {
                        // Remove 've'
                        denominator = denominator.slice(0, denominator.length - 2);
                        denominator += 'f';
                    // Eight => Eighths
                    } else if (bottom.endsWith('8')) {
                        // Remove 't'
                        denominator = denominator.slice(0, denominator.length - 1);
                    }
                    denominator += 'ths';
                }
            }

            console.log('Numerator => ', numerator);
            console.log('Denominator => ', denominator);
            // Capitalize
            numerator = numerator.replace(numerator.charAt(0), numerator.charAt(0).toUpperCase());

            let royaltyToWords = numerator.concat('-' + denominator);
            return royaltyToWords;
        } catch (e) {
            return '0';
        }
    }

    public static decimalToFraction(decimal: number): string {
        const epsilon = 1e-8;

        if (decimal >= .111 && decimal <= .11111) {
            return '1/9';
        } else if (decimal > .14283 && decimal < .14286) {
            return '1/7';
        } else if (decimal >= .166 && decimal <= .1667) {
            return '1/6';
        } else if (decimal >= .333 && decimal <= .33333) {
            return '1/3';
        } 

        let numerator = Math.round(decimal * 1000000);
        let denominator = 1000000;

        // Find the greatest common divisor
        const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));

        // Simplify the fraction
        const commonDivisor = gcd(numerator, denominator);
        numerator /= commonDivisor;
        denominator /= commonDivisor;

        // Continue rounding until the desired precision is achieved
        while (Math.abs(decimal - numerator / denominator) > epsilon) {
            if (decimal > numerator / denominator) {
                numerator++;
            } else {
                denominator++;
            }
        }

        return `${numerator}/${denominator}`;

    }

    public static numberToCurrency(numberValue: number) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        return formatter.format(numberValue);
    }
}



// WEBPACK FOOTER //
// ./src/util/MathUtil.ts